import { render, staticRenderFns } from "./centres-data.vue?vue&type=template&id=2e14c876"
import script from "./centres-data.vue?vue&type=script&lang=js"
export * from "./centres-data.vue?vue&type=script&lang=js"
import style0 from "./centres-data.vue?vue&type=style&index=0&id=2e14c876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports